var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.fileList),function(item){return _c('div',{key:item,staticClass:"title-box",on:{"click":function($event){return _vm.download(item)}}},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title)+_vm._s(_vm.getFileName(item)))])])}),(_vm.innerVisible)?_c('el-image-viewer',{staticStyle:{"z-index":"8888"},attrs:{"on-close":() => {
        _vm.innerVisible = false;
      },"url-list":_vm.fileList}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }